import React, { Component } from "react";
import {Modal} from 'react-bootstrap';
import CSATAuditorScreen from './CSATAuditorScreen'
export default class ModalForm  extends Component {
  render(){  
    let title = this.props.region.inventoryRegionName+' / '+this.props.center.inventoryCenterName+' / '+
    this.props.client.inventoryClientName+' / '+this.props.process.inventoryProcessName
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
      backdrop='static'           
      keyboard={false}
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        CSAT Form For - {title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CSATAuditorScreen auditorJson={this.props.template[0]} userData={this.props.csatuserData}
          loginUserName={this.props.loginUserName}
         region={this.props.region} center={this.props.center} client={this.props.client} process={this.props.process}
         function={this.props.function} closeModal={this.props.closeModal}/> 
        </Modal.Body>
      </Modal>

    )
  }
}